import Link from "next/link";

import { twMerge } from "tailwind-merge";

import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";

import FontAwesomeIcon from "components/FontAwesomeIcon";

type ComparableEntitySnippetProps = {
  className?: string;
  href?: string;
  item: any;
  newTab?: boolean;
  onSelectEntity?: (_entity: any) => void;
};

const ComparableEntitySnippet = ({
  className,
  href,
  item,
  newTab,
  onSelectEntity,
}: ComparableEntitySnippetProps) => {
  const entity = item?.entity || item;
  const name = entity?.pretty_name || entity?.prettyName;
  const ticker = entity?.bloomberg_ticker || entity?.security;
  const label = ticker ? `${name} (${ticker})` : name;

  if (!entity?.id || !label) return null;

  const content = (
    <>
      <div className="flex-1">{label}</div>
      <div className="flex w-[20px] group-hover:justify-end">
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    </>
  );

  const classes = twMerge(
    "border border-solid border-smart-teal rounded-[8px] flex items-center justify-center",
    "py-[8px] px-[16px] text-[14px] text-smart-teal leading-[1]",
    "hover:bg-smart-teal hover:text-white cursor-pointer transition-all",
    "group no-underline",
    className
  );

  if (href) {
    return (
      <Link
        href={href}
        className={classes}
        target={newTab ? "_blank" : undefined}
        rel={newTab ? "noopener noreferrer" : undefined}
      >
        {content}
      </Link>
    );
  }

  return (
    <div className={classes} onClick={() => onSelectEntity?.(entity)}>
      {content}
    </div>
  );
};

export default ComparableEntitySnippet;
